import { Space } from 'antd';
import { reportTypeMap } from '.';
import AgentReportContainer from '../../../containers/Pages/ReportsPage/AgentReport/AgentReportContainer';
import AgentStatusReportContainer from '../../../containers/Pages/ReportsPage/AgentStatusReport/AgentStatusReportContainer';
import AgentStatusSnapshotReportContainer from '../../../containers/Pages/ReportsPage/AgentStatusSnapshotReport/AgentStatusSnapshotReportContainer';
import CallReportContainer from '../../../containers/Pages/ReportsPage/CallReport/CallReportContainer';
import ChatReportContainer from '../../../containers/Pages/ReportsPage/ChatReport/ChatReportContainer';
import ExternalReportsContainer from '../../../containers/Pages/ReportsPage/ExternalReportsContainer';
import TicketReportContainer from '../../../containers/Pages/ReportsPage/TicketReport/TicketReportContainer';

const ReportSelectionLayout = ({ type }): JSX.Element => {
    return (
        <Space direction="vertical" size="large" className="full-width">
            {renderReport(type)}
        </Space>
    );
};

const renderReport = (reportType: string): JSX.Element => {
    switch (reportType) {
        case reportTypeMap.agents:
            return <AgentReportContainer />;
        case reportTypeMap.tickets:
            return <TicketReportContainer />;
        case reportTypeMap.chat:
            return <ChatReportContainer />;
        case reportTypeMap.call:
            return <CallReportContainer />;
        case reportTypeMap.external:
            return <ExternalReportsContainer />;
        case reportTypeMap.agent_status:
            return <AgentStatusReportContainer />;
        case reportTypeMap.agent_status_snapshot:
            return <AgentStatusSnapshotReportContainer />;
        default:
            return <></>;
    }
};

export default ReportSelectionLayout;
